import React from 'react'
import LeftBar from '../../Components/LeftBar' 
import Dashnav from '../../Components/Dashnav'
import TargetReportComp from './TargetReportComp'

function TargetReport() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <TargetReportComp/>      
        </div>
    </div>
  )
}

export default TargetReport